import ResultTable from "../../components/table/ResultTable";
import ResultHeader from "../../components/table/ResultHeader";
import ResultRow from "../../components/table/ResultRow";
import ResultHeaderCell from "../../components/table/ResultHeaderCell";
import HecRasHelper from "../../helpers/HecRasHelper";
import ResultBody from "../../components/table/ResultBody";
import ResultBodyCell from "../../components/table/ResultBodyCell";

export default function FlowChangeTable({data, profiles, selectedCS}) {

    return (
        <ResultTable maxWidth={HecRasHelper.getWidth(5 + 12 + (profiles?.length*10))}>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(5)}}>#</ResultHeaderCell>
                    <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>RS</ResultHeaderCell>
                    {
                        profiles.map(p => (
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                {p}
                            </ResultHeaderCell>
                        ))
                    }
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                {
                    data?.map((row, idx) => {
                        return (
                            <ResultRow style={{fontWeight: selectedCS === row?.cross_section ? 'bold' : ''}}>
                                <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(5)}}>{idx+1}</ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>{row?.cross_section}</ResultBodyCell>
                                {
                                    row?.flow_locations?.map(fl => (
                                        <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                            {fl}
                                        </ResultBodyCell>
                                    ))
                                }
                            </ResultRow>
                        )
                    })
                }
            </ResultBody>
        </ResultTable>
    )
}